import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IKeyData } from "infrastructure";
import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";

import { ISecurityRole, getInitialSecurityRolesState, ISecurityRolesState } from "./SecurityRole.state";

export const roles = createSlice({
  name: "roles",
  initialState: getInitialSecurityRolesState(),
  reducers: {
    loadSecurityRoles: (state, action: PayloadAction<IKeyData>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: true, notification: undefined }
      };
    },
    loadSecurityRolesCompleted: (state, action: PayloadAction<IKeyData<ISecurityRole[]>>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, items: action.payload.data, initialized: true }
      };
    },
    loadSecurityRolesFailed: (state, action: PayloadAction<IKeyData<INotification>>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, notification: action.payload.data, items: state[action.payload.id]?.items || [] }
      };
    },
    reset: actionProcessing.createWithClearNotification((state: ISecurityRolesState, action: PayloadAction<IKeyData>) => {
      const { [action.payload.id]: _, ...rest } = state;

      return {
        ...rest
      };
    }),
    clearSecurityRoles: (state, action: PayloadAction<IKeyData>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, items: [] }
      };
    }
  }
});
